<!--
  ~ Copyright (C) 2020 to Present Applause App Quality, Inc. All rights reserved.
  -->

<ng-content />

@let collapsedPillsCount = (collapsedPills?.count$ | async) ?? 0;
@if (!!collapsedPillsCount) {
  <button type="button" class="toggle-btn"
          #toggleBtn
          [class.large]="largePills"
          [class.active]="isOpen"
          [attr.aria-expanded]="isOpen"
          [attr.aria-haspopup]="'dialog'"
          [attr.aria-controls]="dialogId"
          [attr.aria-label]="'+' + collapsedPillsCount + ' collapsed pills'"
          (click)="toggle($event)"
          (keydown.escape)="onToggleBtnEscape($event)"
          (keydown.space)="$event.stopPropagation()"
          (keydown.enter)="$event.stopPropagation()">
    +{{collapsedPillsCount}}
  </button>
}

<ng-template cdkConnectedOverlay
             cdkConnectedOverlayLockPosition
             [cdkConnectedOverlayPanelClass]="largePills ? 'ngf-pill-list-overlay-panel-fixed-dimensions' : null"
             [cdkConnectedOverlayOpen]="isOpen"
             [cdkConnectedOverlayOrigin]="elementRef"
             [cdkConnectedOverlayPositions]="positions"
             [cdkConnectedOverlayPush]="true"
             [cdkConnectedOverlayScrollStrategy]="scrollStrategy"
             [cdkConnectedOverlayViewportMargin]="16"
             (positionChange)="onPositionChange()"
             (detach)="close()"
             (overlayOutsideClick)="outsideClick($event)">
  <div class="ngf-collapsed-pills-wrapper"
       role="dialog"
       [id]="dialogId"
       aria-label="Selected items"
       cdkTrapFocus
       cdkTrapFocusAutoCapture
       [class.show-chevron]="showChevron"
       [class.active]="isOpen"
       [class.visible]="isPositioned"
       [style.--ngf-chevron-offset]="chevronOffset"
       (keydown.escape)="onOverlayEscape($event)">
    @if (showClearAll) {
      <div class="ngf-collapsed-pills-console">
        <button type="button" ngfLink class="clear-all" (click)="onClearAll()">Clear selected</button>
      </div>
    }
    <div class="ngf-collapsed-pills-container" [style.min-width.px]="largePills ? null : elementRect.width">
      <ng-container [ngTemplateOutlet]="collapsedPills.templateRef"></ng-container>
    </div>
  </div>
</ng-template>
